<template>
  <div>
    <!--  -->

    <div v-if="showtoolbar" class="px-0">

      <b-row class="px-0 mt-0">
        <b-col cols="auto">
          <b-button-group class="z-0">
            <b-row align-h="start" no-gutters>
              <b-col class="gridtoolbar" cols="auto" v-for="(tool, index) in toolbar.filter((o) =>
                o.position.includes('toolbar')
              )" :key="index">
                <b-button v-if="tool.type == 'button' && tool.visible" :id="'tool_' + tool.action" :size="tool.size"
                  :variant="tool.variant" :title="tool.tooltip ? tool.tooltip : toolLabel(tool)"
                  :squared="tool.squared ? 'squared' : null" :disabled="tool.action == 'paste'
                    ? $store.state.clipboard
                      ? false
                      : true
                    : tool.disabled
                    " @click="toolClick(null, tool.action)">
                  <i v-if="toolIcon(tool)" :class="toolIcon(tool)"></i>
                  <span v-if="toolLabel(tool)" v-html="toolLabel(tool)"> </span>
                  <i v-if="tool.icon2" :class="tool.icon2"></i>
                </b-button>
              </b-col>
            </b-row>
          </b-button-group>
        </b-col>
      </b-row>
    </div>
    <div v-if="showfab" :class="fab_bar ? 'btn-group-fab active' : 'btn-group-fab'" role="group" aria-label="FAB Menu"
      @click="fab_bar = !fab_bar">
      <div>
        <button id="menu" type="button" class="btn btn-main btn-primary has-tooltip" data-placement="left">
          <!-- title="Menu" -->
          <i :class="fab_bar ? 'fa fa-times' : 'fa fa-bars'"></i>
        </button>
        <b-tooltip target="menu" placement="right">Click for actions</b-tooltip>
        <div v-for="(tool, index) in toolbar.filter((o) =>
          o.position.includes('toolbar')
        )" :key="index">
          <b-button :id="'fab_' + tool.action" type="button" class="btn btn-sub btn-outline-primary has-tooltip"
            data-placement="left" :style="'bottom: ' + bottom(index) + 'px'"
            @click="toolClick($event, tool.action, checked_items)">
            <i v-if="toolIcon(tool)" :class="toolIcon(tool)"></i>
            <!-- :title="tool.tooltip ? tool.tooltip : toolLabel(tool)" -->
          </b-button>
          <b-tooltip :target="'fab_' + tool.action" placement="right">{{
            tool.tooltip ? tool.tooltip : toolLabel(tool)
          }}</b-tooltip>
        </div>
      </div>
    </div>
    <!-- {{ height }} -->
    <div class="px-0">
      <b-overlay :show="overlay_show" opacity=".9" v-click-outside="outside">
        <div :class="classdivtable">
          <b-table :dark="$store.state.darkMode" :ref="refid" :sticky-header="tableheight + 'px'" striped hover small
            caption-bottom show-empty selectable :select-mode="selectmode" foot-clone :no-local-sorting="unsortable"
            no-footer-sorting :busy="busy" :items="items" :fields="fields" :tbody-tr-class="rowClass"
            @row-selected="rowSelected($event)">
            <template #head(selected)>
              <i id="selectall" class="ml-1" :class="headselected()" aria-hidden="true" @click="headselectedClick()"
                title="Click to select/unselect all"></i>
            </template>

            <template #cell(selected)="{ rowSelected }">
              <template v-if="rowSelected">
                <span aria-hidden="true">&check;</span>
                <span class="sr-only">Selected</span>
              </template>
              <template v-else>
                <span aria-hidden="true">&nbsp;</span>
                <span class="sr-only">Not selected</span>
              </template>
            </template>
            <template v-slot:table-busy>
              <div class="text-center my-2">
                <b-spinner type="grow" variant="primary" class="align-middle mr-2"></b-spinner>
                <strong class="text-primary">Loading...</strong>
              </div>
            </template>
            <template v-slot:cell(icon)="slot">
              <span v-if="rownumbers" class="small text-primary mr-1">{{ offset + slot.index + 1 }}.</span>
              <i :class="rowIcon(slot.item)" :title="slot.item.type ? slot.item.type : null"></i>
            </template>
            <template v-slot:cell(emission)="slot">
              <span v-if="slot.item.emission == '<api pending>'" class="text-warning">
                &lt;api pending&gt;
              </span>
              <span v-else>{{ slot.item.emission }}</span>
            </template>
            <template v-slot:cell(distance)="slot">
              <span v-if="slot.item.distance == '<api pending>'" class="text-warning">
                &lt;api pending&gt;
              </span>
              <span v-else>{{ slot.item.distance }}</span>
            </template>
            <template v-slot:cell(emailed_at)="slot">
              <i :class="slot.item.emailed_at
                ? 'fa fa-envelope text-primary'
                : 'fa fa-envelope-o text-warning'
                " :title="slot.item.emailed_at
                  ? 'ETR Emailed ' + slot.item.emailed_at
                  : 'ETR Pending'
                  "></i>
            </template>

            <template v-slot:cell(invoiceno)="slot">
              <i v-if="slot.item.notes" class="fa fa-info-circle text-black pr-1"
                :id="slot.item.invoiceno + '_tooltip'"></i>
              <span>{{ slot.item.invoiceno }}</span>
              <b-tooltip :target="slot.item.invoiceno + '_tooltip'" triggers="hover" placement="right">{{
                slot.item.notes }}</b-tooltip>
            </template>

            <template v-slot:cell(ref)="slot">
              <i v-if="slot.item.notes" class="fa fa-info-circle text-black pr-1" :id="slot.item.ref + '_tooltip'"></i>
              <span>{{ slot.item.ref }}</span>
              <b-tooltip :target="slot.item.ref + '_tooltip'" triggers="hover" placement="right">{{
                slot.item.notes }}</b-tooltip>
            </template>

            <template v-slot:cell()="slot">
              <span v-html="cellBadge(slot)"></span>

            </template>

            <template v-slot:cell(actions)="row">
              <!-- <div id="actions-container" v-if="options.actions_as_elipses">
              <b-button
                variant="link"
                size="sm"
                title="Actions"
                :id="'popover-target-' + row.item.id"
                @click="$root.$emit('bv::hide::popover')"
              >
                <i class="fa fa-ellipsis-h text-primary"></i>
              </b-button>
              <b-popover
                container="actions-container"
                triggers="click blur"
                placement="leftbottom"
                :target="'popover-target-' + row.item.id"
              >
                <div>
                  <b-nav vertical>
                    <b-nav-item
                      :title="action.label"
                      v-for="action in rowActionCell(row.item, options)"
                      :key="action.key"
                      @click.stop="rowClick(action.key, row, options.bvtid)"
                    >
                      <b-row class="px-2">
                        <b-col class="px-0">
                          <span class="text-normal">{{ action.label }}</span>
                        </b-col>
                        <b-col cols="1">
                          <i :class="rowActionIcon(action, row.item)"></i>
                        </b-col>
                      </b-row>
                    </b-nav-item>
                  </b-nav>
                </div>
              </b-popover>
            </div> -->
              <div>
                <b-button variant="link" size="sm" v-for="tool in actionsvalid(row)" :key="tool.action" :title="tool.labelprop
                  ? row.item[tool.labelprop]
                    ? tool.label + ' ' + row.item[tool.labelprop]
                    : tool.label
                  : tool.label
                  " @click.stop="toolClick(row, tool.action)">
                  <i :class="tool.icon"></i>
                </b-button>
              </div>
            </template>

            <template v-slot:foot()="row">
              <span v-if="row.field.totalled" :id="'total_' + row.field.key" :class="'text-white'" class="strong">
                {{ row.field.total }}</span>
              <b-tooltip v-if="row.field.totalled" :target="'total_' + row.field.key" triggers="hover"
                placement="right">{{ row.field.total }}</b-tooltip>
              <span v-else></span>
            </template>
          </b-table>
        </div>

        <template #overlay>
          <div class="text-center">
            <p id="cancel-label">{{ overlay.message }}</p>
            <hr />
            <b-row>
              <b-col>
                <b-button v-for="(button, index) in overlay.buttons" :key="index"
                  :style="button.style ? button.style : 'width: 80px'" :class="button.class
                    ? button.class
                    : button.dispatch
                      ? null
                      : 'ml-2'
                    " :variant="button.variant
                      ? button.variant
                      : button.action
                        ? 'outline-primary'
                        : 'outline-secondary'
                      " :size="button.size ? button.size : 'sm'" :squared="button.squared ? button.squared : true"
                  @click="
                    button.action
                      ? toolClick($event, button.action)
                      : (overlay_show = false)
                    ">{{ button.label }}</b-button>
              </b-col>
            </b-row>
          </div>
        </template>
      </b-overlay>
    </div>
    <!-- mt-n3 ? -->
    <b-row v-if="showsheets" class="excelsheetbuttons ">
      <b-col>
        <b-button-group>
          <b-button v-for="(tool, index) in toolbar.filter((t) =>
            t.action.includes('sheet_')
          )" :key="index" :size="tool.size" :variant="tool.variant"
            :title="tool.tooltip ? tool.tooltip : toolLabel(tool)" :id="'sheet_' + tool.action"
            :pressed="table_tab == index" type="button" class="status" @click="
              table_tab = index;
            toolClick(null, tool.action);
            ">
            <i v-if="toolIcon(tool)" :class="toolIcon(tool)"></i>
            {{ tool.label }}
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>

    <!-- z-10 -->
    <!-- v-if="!component" -->
    <b-row class="excelsheetbuttons px-0 mt-2 z-0">
      <b-col v-if="!busy" class="text-left" cols="10">
        <span v-if="showrowcount" class="small text-primary">Found {{ rowslabel }}</span><span v-if="showpages"
          class="small text-primary">, {{ pageslabel }}</span>
      </b-col>
      <b-col v-if="showpages" class="text-right ml-auto" cols="auto">
        <b-row>
          <b-col cols="auto">
            <b-pagination hide-ellipsis v-if="rows > 0" v-model="page_" :total-rows="rows" :per-page="limit_"
              :align="'right'" size="sm"></b-pagination>
          </b-col>
          <b-col cols="auto">
            <div class="pagelimit">
              <treeselect v-model="limit_" :clearable="false" :options="options_pagesizes" size="sm" inline>
              </treeselect>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- 
    {{ offset }} {{ limit }} {{ page }} {{ pages }} <br/>
    {{ page_ }} {{ limit_ }} -->
    <!-- <Pastespecial />
    <NotesEdit :selection="selected" @changed="changed" /> -->

    <b-modal id="download-file" v-model="download_show" centered title="Download" @close="handleCancel()"
      :modal-class="{ 'c-dark-theme': $store.state.darkMode }">

      <template #default="{ hide }">

        <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-row>
            <b-col cols="12">
              <b-form-group label="Download selection" label-for="type" label-cols="12">
                <treeselect instanceId="download_type" type="number" v-model="download" :clearable="false"
                  :options="options_download" @input="download_change"></treeselect>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group label="File format" label-for="type" label-cols="12">
                <treeselect instanceId="download_format" type="number" v-model="download_file" :clearable="false"
                  :options="options_download_file"></treeselect>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="mt-2" cols="12" v-if="downloaded.length == 0">
              <b-row no-gutters>
                <b-col cols="auto"> <i class="fa fa-cog fa-spin text-primary" style="font-size:24px"></i></b-col>
                <b-col class="pl-2"> <span>One moment we are fetching that data for you...</span></b-col>
              </b-row>
            </b-col>
          </b-row>

        </form>
      </template>

      <template #modal-footer="{ ok, cancel, hide }">
        <span v-if="downloaded.length > 0" class="mr=4">Ready to export {{ downloaded.length }} row(s)</span>

        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="outline-primary" @click="handleSubmit()" :disabled="downloaded.length == 0">
          <i :class="downloading ? 'fa fa-refresh fa-spin text-info mr-1' : 'fa fa-download text-info mr-1'"></i>
          <span v-text="downloading ? 'Downloading' : 'Download It'"></span>
        </b-button>
        <b-button size="sm" variant="secondary" @click="handleCancel()">
          <i class="fa fa-chevron-left pr-1"></i>Back
        </b-button>
        <!-- Button with custom close trigger value -->
        <!-- <b-button size="sm" variant="outline-secondary" @click="hide('forget')">
          Forget it
        </b-button> -->
      </template>
    </b-modal>


  </div>
</template>

<script>
import * as toolsetup from "./toolsetup";
import * as fs from "file-saver";

export default {
  name: "d-table",
  props: {
    classdivtable: { type: String, default: "availtable datatable" },
    refid: { type: String, default: "d-table" },
    busy: { type: Boolean, default: false },
    unsortable: { type: Boolean, default: true },
    icon: { type: String, default: "fa fa-power-off" },
    tools: { type: String, default: "" },
    toolbar: {
      type: Array,
      default() {
        return [];
      },
    },
    toolbarlibrary: {
      type: Array,
      default() {
        return [];
      },
    },
    downloaded: {
      type: Array,
      default() {
        return [];
      },
    },
    fields: {
      type: Array,
      default() {
        return [];
      },
    },
    icons: {
      type: Array,
      default() {
        return [];
      },
    },
    badges: {
      type: Array,
      default() {
        return [];
      },
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    actions: {
      type: Array,
      default() {
        return [];
      },
    },
    selectall: { type: Boolean, default: false },
    selectmode: { type: String, default: "multi" },
    title: { type: String, default: "Not specified" },
    rownumbers: { type: Boolean, default: true },
    showtoolbar: { type: Boolean, default: true },
    showfab: { type: Boolean, default: false },
    showsheets: { type: Boolean, default: false },
    showpages: { type: Boolean, default: true },
    showrowcount: { type: Boolean, default: true },
    page: { type: Number, default: 1 },
    offset: { type: Number, default: 0 },
    limit: { type: Number, default: 15 },
    maxheight: { type: Number, default: 0 },
  },
  mounted() {
    this.resizableColumns();
  },
  watch: {
    items: {
      immediate: true,
      deep: true,
      async handler(newVal, oldVal) {

        let result = [];

        if (newVal) {
          // CLEAR TOTALS WE MIGHT NOT HAVE ANY ITEMS
          for (let i = 0; i < this.fields.length; ++i) {
            let field = this.fields[i];
            if (field.totalled) {
              field.total = 0;
            }
          }
          this.rows = newVal.length.toString();
          for (let j = 0; j < newVal.length; j++) {
            let item = newVal[j];

            if (j == 0 && this.fields.length == 0) {
              this.fields.push({
                key: "selected",
                label: "...",
              });
              this.fields.push({
                key: "icon",
                label: "",
                class: "text-center w-30px",
              });

              for (let prop in item) {
                // HIDE BUT STILL THERE
                switch (prop) {
                  case "id":
                  case "index":
                  case "locked_at":
                  case "locked_by":
                  case "locked":
                  case "seatid":
                  case "avid":
                    break;

                  default:
                    this.fields.push({
                      key: prop,
                      label: prop,
                    });
                }
              }
            }

            delete item["__typename"];
            if (j == 0 && item.rows) {
              this.rows = item.rows;
            }

            if (this.fields) {
              for (let i = 0; i < this.fields.length; ++i) {
                let field = this.fields[i];

                if (field.type == "daterangepicker") {
                  if (!item[field.key]) {
                    item[field.key] = { startDate: null, endDate: null };
                  }

                  if (Array.isArray(item[field.key])) {
                    item[field.key] = {
                      startDate: item[field.key][0],
                      endDate: item[field.key][1],
                    };
                  }
                }

                if (field.totalled) {
                  field.total = 0;
                  if (!field.type) {
                    field.type = "float";
                  }
                  for (let k = 0; k < newVal.length; ++k) {
                    let row = newVal[k];

                    let value = 0;
                    if (row[field.key]) {
                      if (field.type == "int") {
                        value = parseInt(row[field.key]);
                      } else {
                        value = parseFloat(row[field.key]);
                      }
                      if (value >= 0) {
                        field.total += value;
                      } else {
                        field.total -= Math.abs(value);
                      }
                    }
                  }
                  if (field.type == "float") {
                    field.total = Math.round(field.total * 100) / 100;
                    field.total = this.$options.filters.currency(field.total, "");
                  }
                }
              }
            }

            result.push(item);

          }

          this.$emit("totalled", this.fields);
          this.$emit("change", []);
          this.$emit("select", this.selected, this.toolbar);

          this.loaded = true
        }
      },
    },
    toolbarlibrary: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal) {
          // ADD NEW TOOLS TO THE INNER toolbar_library
          for (let i = 0; i < newVal.length; i++) {
            let tool = newVal[i];
            if (tool.action) {
              let found = this.toolbarlibrary_.find(
                (o) => o.action == tool.action
              );
              if (!found) {
                if (!tool.disabled) {
                  tool.disabled = true;
                }
                this.toolbarlibrary_.push(tool);
              }
            }
          }
        }
      },
    },
    tools: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal) {
          newVal = newVal
            .split("default")
            .join("back,save,filter,go,export,add,edit,deleteconfirm");
          let list = newVal.split(",");
          this.toolbar = []
          for (let i = 0; i < list.length; i++) {
            let found = this.toolbar.find((o) => o.action == list[i]);
            if (!found) {
              let tool = this.toolbarlibrary_.find((o) => o.action == list[i]);
              if (tool) {
                tool.disabled = true;
                tool.visible = true;
                this.toolbar.push({ ...tool });
              }
            }
          }
          this.$emit("select", [], this.toolbar);
        }
      },
    },
    showpages: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal) {
          this.height = 600;
        } else {
          this.height = 1000;
        }
      },
    },
    selectall: {
      immediate: true,
      async handler(newVal, oldVal) {
        this.selectallitems(newVal);
      },
    },
    page: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (parseInt(newVal) > 0) {
          // console.log("d-table page to", newVal);
        }
      },
    },
    limit: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (parseInt(newVal) > 0) {
          if (newVal != this.limit_) {
            this.limit_ = newVal
            await this.setsize(newVal)
          }
        }
      }
    },
    offset: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (parseInt(newVal) == 0) {
          this.page_ = 1
        }
      }
    },
    page_: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (parseInt(newVal) > 0) {
          if (this.loaded) {
            if (newVal != this.page) {
              console.log("d-table page_ to", newVal);
              this.$emit("load", (newVal - 1) * this.limit, this.limit, newVal);
            }
          }
        }
      },
    },
    limit_: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (parseInt(newVal) > 0) {
          if (this.loaded) {
            if (newVal != this.limit) {
              console.log("d-table size_ to", newVal);
              this.$emit("load", 0, newVal, 1);
            }
          }
        }
      },
    },
  },
  data() {
    return {
      loaded: false,
      page_: 1,
      limit_: 15,
      rows: 0,
      table_tab: 0,
      height: 600,
      selected: [],
      toolbarlibrary_: toolsetup.default.library,
      fab_bar: false,
      options_pagesizes: [
        { id: 15, label: "15" },
        { id: 25, label: "25" },
        { id: 50, label: "50" },
        { id: 100, label: "100" },
        { id: 500, label: "500" },
        { id: 5000, label: "All" },
      ],
      overlay_show: false,
      overlay: {},
      download_show: false,
      download: "download_view",
      options_download: [
        { id: "download_view", label: "Current page" },
        { id: "download_all", label: "All pages" },
      ],
      download_file: "download_xlsx",
      options_download_file: [
        { id: "download_xlsx", label: "Excel Workbook (*.xlsx)" },
        { id: "download_txt", label: "Text (Tab delimited) (*.txt)" },
        { id: "download_csv", label: "CSV (Comma delimited) (*.csv)" },
      ],
      downloading: false,
    };
  },
  computed: {
    sheets() {
      let result = [];
      for (let i = 0; i < this.toolbarlibrary.length; i++) {
        let tool = this.toolbarlibrary[i];
        if (tool) {
          tool.disabled = true;
          tool.visible = true;
          let sections = tool.position.split(",");
          for (let j = 0; j < sections.length; j++) {
            if (sections[j] == "sheets") {
              result.push(tool);
            }
          }
        }
      }
      return result;
    },
    rowslabel() {
      let result = this.rows.toString() + " row"
      if (this.rows == 1) {
        return result
      }
      return result += 's'
    },
    pageslabel() {
      if (this.limit == 0) { return "" }
      let count = Math.ceil(this.rows / this.limit)
      let result = count.toString() + " page"
      if (count == 1) {
        return result
      }
      return result += 's'
    },
    tableheight() {
      let result = 600
      switch (true) {
        case this.limit == 10:
          result = 350;
          break;
        case this.limit == 15:
          result = 600;
          break;
        case this.limit == 25:
          result = 800;
          break;
        case this.limit == 50:
          result = 1600;
          break;
        case this.limit > 50:
          result = 3600;
          break;
      }
      if (this.maxheight != 0) {
        result = this.maxheight
      }
      return result
    }
  },
  methods: {
    download_change() {
      this.$emit("click", this.download);
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid
      return valid
    },
    resetModal() {
      this.name = ''
      this.nameState = null
    },
    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    handleCancel() {
      console.log('you cancelled')
      //Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('download-file')
      })
      this.$emit("load", 0, 15, 1);
    },
    async handleSubmit() {

      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }

      this.downloading = true

      let file = null
      let buffer = null
      let filename = 'export' + this.$moment().format("_YYYYDDMMHHMMSS")
      switch (this.download_file) {
        case "download_xlsx":
          await this.excel_sheet({ items: this.downloaded, fields: this.fields, title: this.title});
          break;

        case "download_txt":
          file = await this.outputTXT("\t", this.downloaded);
          buffer = Buffer.from(file, "utf8");
          fs.saveAs(new Blob([buffer], { type: "text/csv;charset=utf-8" }), filename + ".txt");
          break;

        case "download_csv":
          file = await this.outputTXT(",", this.downloaded);
          buffer = Buffer.from(file, "utf8");
          fs.saveAs(new Blob([buffer], { type: "text/csv;charset=utf-8" }), filename + ".csv");
          break;
      }

      this.downloading = false
    },

    async outputTXT(delim, downloaded) {

      if (!delim) {
        delim = "\t"
      }
      let result = "";

      let fields = this.fields
      let items = this.items
      if (downloaded) { items = downloaded }

      for (let j = 0; j < items.length; j++) {
        let line = "";

        // HEADER
        if (j == 0) {
          for (let k = 0; k < fields.length; k++) {
            if (fields[k].key == "selected" || fields[k].key == "icon" || fields[k].key == "actions") {
            } else {
              line += fields[k].label + delim;
            }
          }
          if (line.length > 0) {
            line = line.slice(0, -1);
          }
          result += line + "\n";
          line = "";
        }

        let obj = items[j];

        // USE FIELDS IN CASE AN OBJECT IS NOT COMPLETE
        for (let k = 0; k < fields.length; k++) {
          let value = "";
          let prop = ""
          if (fields[k].key == "selected" || fields[k].key == "icon" || fields[k].key == "actions") {
          } else {
            value = obj[fields[k].key] ? obj[fields[k].key] : ""
            console.log(fields[k].key)
            if (
              (this.fields[k].key.toLowerCase().includes('date') ||
                this.fields[k].key.toLowerCase().includes('modified') ||
                this.fields[k].key.toLowerCase().includes('issued') ||
                this.fields[k].key.toLowerCase().includes('invoice_at') ||
                this.fields[k].key.toLowerCase().includes('travel_at') ||
                this.fields[k].key.toLowerCase().includes('start_at')
              ) && !this.fields[k].key.toLowerCase().includes('updated')) {

              if (value) {
                if (!this.$moment(value).isValid()) {
                  value = this.$moment.unix(parseFloat(value) / 1000).utc(false).format("DD/MM/YY")
                }
              }
            }
            if (value) {
              value = value
                .toString()
                .replace(/(\r\n|\n|\r)/gm, "")
                .replace(/""/g, '"');
            }

            prop = fields[k].key.toLowerCase()
            line += value + delim;
          }

        }
        if (line.length > 0) {
          line = line.slice(0, -1);
        }

        result += line + "\n";
      }

      return result;
    },

    load() { },
    changed(ss) {
      this.$emit("changed", ss);
    },
    // HELPERS
    resizableColumns() {
      // RE-SIZE COLUMNS
      var thElm;
      var startOffset;

      Array.prototype.forEach.call(
        document.querySelectorAll("table th"),
        function (th) {
          th.style.position = "relative";

          var grip = document.createElement("div");
          grip.innerHTML = "&nbsp;";
          grip.style.top = 0;
          grip.style.right = 0;
          grip.style.bottom = 0;
          grip.style.width = "5px";
          grip.style.position = "absolute";
          grip.style.cursor = "col-resize";
          grip.addEventListener("mousedown", function (e) {
            thElm = th;
            startOffset = th.offsetWidth - e.pageX;
          });

          th.appendChild(grip);
        }
      );

      document.addEventListener("mousemove", function (e) {
        if (thElm) {
          thElm.style.width = startOffset + e.pageX + "px";
        }
      });

      document.addEventListener("mouseup", function () {
        thElm = undefined;
      });
    },
    headselected() {
      if (this.selected.length == 0) {
        return "fa fa-square-o";
      } else if (this.selected.length == this.items.length) {
        return "fa fa-check-square-o";
      } else {
        return "fa fa-minus-square-o";
      }
    },
    headselectedClick() {
      if (this.items.length > 0) {
        if (this.$refs[this.refid]) {
          if (this.selected.length == 0) {
            this.$refs[this.refid].selectAllRows();
            this.$emit("click", "selectall", this.items);
          } else {
            this.$refs[this.refid].clearSelected();
            this.$emit("click", "selectall", this.items);
          }
        }
      }
    },
    rowSelected(items) {
      this.selected = items;
      this.$emit("select", items, this.toolbar);
    },
    rowIcon(r) {
      let result = this.icon
      try {
        let iconsel = ""
        if (this.icons.length > 0) {
          iconsel = this.icons[0].key
        }
        if (iconsel) {
          if (r[iconsel]) {
            let sel = r[iconsel]
            if (this.icons[0][sel]) {
              result = this.icons[0][sel]
            }
          }
        }
      } catch (error) {

      }
      return result
      // let result = this.icon;
      // if (r.running == 1 || r.runnow == 1) {
      //   result += " text-warning";
      // } else {
      //   // result += " text-primary";
      // }
      // return result;
    },
    cellBadge(c) {
      let result = c.value
      let badge = ""
      let badgeValue = null
      if (this.badges) {
        badge = this.badges.find(o => o.key == c.field.key)
        if (badge) {
          switch (badge.type) {
            case "pill":
              var badgeClass = badge.class;
              badgeValue = c.value
              if (badge.formatter) {
                badgeValue = badge.formatter(badgeValue)
              }
              badgeValue = badgeValue.toString().replace(/^\w/, (c) => c.toUpperCase());

              var badgeTitle = badgeValue;
              if (badge.title) {
                // if (c.item[badge.title]) {
                //   badgeTitle = c.item[badge.title];
                // }
              }
              result =
                "<span " +
                "title='" +
                badgeTitle +
                "' " +
                "class='badge badge-" +
                badgeClass +
                " badge-pill'" +
                ">" +
                badgeValue +
                "</span>";
              break;

            case "badge":
              badgeValue = c.value
              if (badge.formatter) {
                badgeValue = badge.formatter(badgeValue)
              }
              var badgeClass = badge[badgeValue];
              if (!badgeClass) {
                badgeClass = badge["other"];
              }
              badgeValue = badgeValue.toString().replace(/^\w/, (c) => c.toUpperCase());
              var badgeTitle = badgeValue;
              if (badge.title) {
                // if (c.item[badge.title]) {
                //   badgeTitle = c.item[badge.title];
                // }
              }
              result =
                "<span " +
                "title='" +
                badgeTitle +
                "' " +
                "class='badge badge-" +
                badgeClass +
                "'" +
                ">" +
                badgeValue +
                "</span>";
              break;

            case "switch":
              var badgeClass = badge[c.value];
              badgeValue = result
                .toString()
                .replace(/^\w/, (c) => c.toUpperCase());
              var checked = "";
              if (value == "enabled") {
                checked = "checked";
              }
              result =
                "<label class='switch-sm switch  switch-label switch-" +
                badgeClass +
                " form-check-label'>" +
                "<input type='checkbox' true-value='" +
                badgeValue +
                "' false-value='no' class='switch-input form-check-input' value='" +
                badgeValue +
                "'" +
                checked +
                ">" +
                "<span class='switch-slider'></span></label>";
              break;

            case "progressbar":
              var badgeClass = badge.class;
              badgeValue = c.value //.toString(); //.substring(0,2)
              if (!badgeClass) {
                badgeClass = "success";
              }
              if (parseFloat(badgeValue) > 100) {
                badgeClass = "danger";
              }
              if (!badge.min) {
                badge.min = 0;
              }
              if (!badge.max) {
                badge.max = 100;
              }
              result =
                "<div role='progressbar' class='progress-bar bg-" +
                badgeClass +
                "'" +
                "aria-valuemin='" +
                badge.min +
                "' " +
                "aria-valuemax='" +
                badge.max +
                "' " +
                "aria-valuenow='" +
                badgeValue +
                "' " +
                "title='" +
                badgeValue +
                "%' " +
                "style='width: " +
                badgeValue +
                "%;'>";
              if (badge.label) {
                result = result + badgeValue;
              }
              result = "</div><div class='progress'>" + result + "</div>";
              break;
          }
        }
      }
      return result
    },
    rowBadgeCell(row, badge, r) {
      console.log(r)
      let badgesel = ""
      if (this.badges.length > 0) {
        badgesel = this.badges.find(o => o.key == badge.key)
      }
      if (!row || !badge.key) return;
      var key = badge.key;
      // if (badge.key == 'type') {
      // }
      if (!row.hasOwnProperty([badge.key])) {
        return;
      }
      var value = row[badge.key];
      if (badge.formatter) {
        value = badge.formatter(value, badge.key, row);
      }
      if (!value) {
        return;
      }
      var badge = this.badges.find((k) => k.key == key);
      // if (key == 'type') {
      // }
      if (badge) {
        switch (badge.type) {
          case "pill":
            var badgeClass = badge.class;
            var badgeValue = value
              .toString()
              .replace(/^\w/, (c) => c.toUpperCase());
            var badgeTitle = badgeValue;
            if (badge.title) {
              if (row[badge.title]) {
                badgeTitle = row[badge.title];
              }
            }
            value =
              "<span " +
              "title='" +
              badgeTitle +
              "' " +
              "class='badge badge-" +
              badgeClass +
              " badge-pill'" +
              ">" +
              badgeValue +
              "</span>";
            break;

          case "badge":
            var badgeClass = badge[value];
            if (!badgeClass) {
              badgeClass = badge["other"];
            }
            var badgeValue = value
              .toString()
              .replace(/^\w/, (c) => c.toUpperCase());
            var badgeTitle = badgeValue;
            if (badge.title) {
              if (row[badge.title]) {
                badgeTitle = row[badge.title];
              }
            }
            value =
              "<span " +
              "title='" +
              badgeTitle +
              "' " +
              "class='badge badge-" +
              badgeClass +
              "'" +
              ">" +
              badgeValue +
              "</span>";
            break;

          case "switch":
            var badgeClass = badge[value];
            var badgeValue = value
              .toString()
              .replace(/^\w/, (c) => c.toUpperCase());
            var checked = "";
            if (value == "enabled") {
              checked = "checked";
            }
            value =
              "<label class='switch-sm switch  switch-label switch-" +
              badgeClass +
              " form-check-label'>" +
              "<input type='checkbox' true-value='" +
              badgeValue +
              "' false-value='no' class='switch-input form-check-input' value='" +
              badgeValue +
              "'" +
              checked +
              ">" +
              "<span class='switch-slider'></span></label>";
            break;

          case "progressbar":
            var badgeClass = badge.class;
            var badgeValue = value.toString(); //.substring(0,2)
            if (!badgeClass) {
              badgeClass = "success";
            }
            if (parseFloat(badgeValue) > 100) {
              badgeClass = "danger";
            }
            if (!badge.min) {
              badge.min = 0;
            }
            if (!badge.max) {
              badge.max = 100;
            }
            value =
              "<div role='progressbar' class='progress-bar bg-" +
              badgeClass +
              "'" +
              "aria-valuemin='" +
              badge.min +
              "' " +
              "aria-valuemax='" +
              badge.max +
              "' " +
              "aria-valuenow='" +
              badgeValue +
              "' " +
              "title='" +
              badgeValue +
              "%' " +
              "style='width: " +
              badgeValue +
              "%;'>";
            if (badge.label) {
              value = value + badgeValue;
            }
            value = "</div><div class='progress'>" + value + "</div>";
            break;
        }
      }
      return value;
    },
    // TOOLBAR HELPERS
    async toolClick($event, a, s) {
      console.log("toolClick: ", $event, a, s);

      this.overlay_show = false;

      // let tool = this.toolbar.find((o) => o.action == a);
      // if (tool) {
      //   if (tool.disabled && !tool.position.includes("action")) {
      //     return;
      //   }
      // }

      switch (a) {
        // case "sheet_0":
        // case "sheet_1":
        // case "sheet_2":
        // case "sheet_3":
        // case "sheet_4":
        // case "sheet_5":
        // case "sheet_6":
        // case "sheet_7":
        // case "sheet_8":
        // case "sheet_9":
        //   break;

        // case "filter":
        //   this.showfilter = !this.showfilter;
        //   break;
        case "download":
          if (this.items.length > 0) {
            if (!this.download_show) {
              this.download = "download_view"
              this.download_file = "download_xlsx"
              this.downloaded = this.items
            }
            this.download_show = !this.download_show;
          }
          break;

        case "autoquery":
          this.autoquery = !this.autoquery;
          break;

        case "clipboard":
          let x = await this.outputTSV()
          await navigator.clipboard.writeText(x);
          break;


        case "discard":
          this.component = null;
          this.selected = [];
          if (this.$refs[this.refid]) {
            this.$refs[this.refid].clearSelected();
          }
          break;

        case "selectall":
          if (!this.selectall) {
            this.selected = [];
          }

        case "refresh":
          this.selected = [];
          if (this.$refs[this.refid]) {
            this.$refs[this.refid].clearSelected();
          }
          break;

        case "export":
          await this.excel_sheet({
            items: this.selected.length > 0 ? this.selected : this.items,
            fields: this.fields,
            title: this.title
          });
          break;

        // case "add":
        // case "import":
        default:
          let index = 0;
          let item = null;

          console.log("default case");
          if ($event) {
            index = $event.index + 1;
            item = $event.item;
            if (item) {
              this.$emit("select", [this.items[$event.index]], this.toolbar);

              if (this.$refs[this.refid]) {
                this.$refs[this.refid].selectRow($event.index);
              }

              // // MIXIN COMPAITBILITY
              this.selection = this.items[$event.index];
            }
          } else {
            if (this.selected.length > 0) {
              item = this.items.find(
                (o) => o.id == this.selected[this.selected.length - 1].id
              );
              item.index = this.items.map((e) => e.id).indexOf(item.id) + 1;
            }
          }

          let toolactive = this.toolbar.find((o) => o.action == a);

          if (a == "add") {
            this.selected = [];
            if (this.$refs[this.refid]) {
              this.$refs[this.refid].clearSelected();
            }
          }

          // try {

          this.$emit("click", a, this.selected);
          // } catch (error) { }
          // CLEAR THE SELECTION IF ADDING!

          if (toolactive) {
            if (toolactive.component) {
              if (toolactive.component.name == this.component) {
                this.component = null;
                this.cconfig = null;
              } else {
                this.component = toolactive.component.name;
                if (toolactive.component.config) {
                  this.cconfig = toolactive.component.config;
                }
                this.cconfig = { action: a, ...this.config };
              }
            }
            if (toolactive.hasOwnProperty("overlay")) {
              if (toolactive.overlay.message) {
                let message = toolactive.overlay.message;

                // IF WE DID NOT ALREADY HAVE IT IN DATA MAKE THE INDEX FROM THE LIST

                if (index == 0 && this.selected.length > 0) {
                  message = message.split("row %index%").join(this.selected.length + " row(s)")
                } else {
                  for (let prop in item) {
                    if (Object.prototype.hasOwnProperty.call(item, prop)) {
                      message = message.split("%" + prop + "%").join(item[prop]);
                    }
                  }
                  message = message
                    .split("%index%")
                    .join(this.offset + index);
                }

                this.overlay.message = message;
              }
              if (toolactive.overlay.buttons) {
                this.overlay.buttons = toolactive.overlay.buttons;
              }
              this.overlay_show = !this.overlay_show;
              return;
            }
          }
          break;
      }
      // try {
      //   this.$emit("click", a, this.selected);
      // } catch (error) { }
    },
    toolLabel(a) {
      switch (a.action) {
        case "filter":
          return this.showfilter ? "Filter On" : "Filter Off";
        case "autoquery":
          return this.autoquery ? "Auto On" : "Auto Off";
        default:
          return a.label;
      }
    },
    toolIcon(a) {
      switch (a.action) {
        // case "filter":
        //     return this.showfilter ? a.icon + ' text-danger' : a.icon + ' text-primary'
        default:
          return a.icon;
      }
    },
    toolRemove(a) {
      if (a) {
        let list = a.split(",");
        for (let i = 0; i < list.length; i++) {
          let idx = this.tools.findIndex((o) => o.action == list[i]);
          if (idx != -1) {
            this.tools.splice(idx, 1);
          }
        }
      }
    },
    toolComponents(a) {
      for (let i = 0; i < a.length; i++) {
        let tool = a[i];
        let component = this.tools.find(
          (o) => o.action == tool.action
        ).component;
        if (component) {
          for (let prop in tool) {
            if (tool[prop] != "action") {
              component[prop] = tool[prop];
            }
          }
        }
      }
    },
    actionsvalid(item) {
      var valid = [];

      let actions = this.toolbar.filter((o) => o.position.includes("actions"));

      for (let i = 0; i < actions.length; i++) {
        let action = actions[i];
        if (action.visible) {
          if (action.rule) {
            var rule = action.rule;
            var op = rule.toString().substring(0, 1);
            var equalTo = true;
            if (op == "!") {
              equalTo = false;
              rule = rule.substring(1);
            }
            if (item.hasOwnProperty(rule)) {
              var state = item[rule];
              if (
                (state == true && equalTo == true) ||
                (state == false && equalTo == false)
              ) {
                valid.push(action);
              }
            } else {
              valid.push(action);
            }
          } else {
            valid.push(action);
          }
        }
      }
      return valid;
    },
    async setsize(s) {
      if (this.showpages) {
        if (s == 10) {
          this.height = 350;
        }
        if (s == 15) {
          this.height = 600;
        }
        if (s == 25) {
          this.height = 800;
        }
        if (s == 50) {
          this.height = 1600;
        }
        if (s > 50) {
          this.height = 3600;
        }
      } else {
        this.height = 1000;
      }
    },
    async selectallitems(v) {
      if (this.$refs[this.refid]) {
        if (v) {
          // this.headselectedClick();
          this.$refs[this.refid].selectAllRows();
        } else {
          this.$refs[this.refid].clearSelected();
        }
      }
    },
    bottom(index) {
      let result = 0;
      if (this.fab_bar) {
        if (index == 0) {
          result = 60;
        } else {
          result = 60 + index * 50;
        }
      }
      return result;
    },
    rowClass(item, type) {
      if (item && type === "row") {
        if (item.new === true) {
          return "new";
        } else if (item.locked_at) {
          return "row-debit";
        } else if (parseFloat(item.cost) < 0) {
          return "row-debit"
        } else if (parseFloat(item.sum_total) < 0) {
          return "row-debit"
        } else if (parseFloat(item.line_exvat) < 0) {
          return "row-debit"
        } else if (parseFloat(item.amount) < 0) {
          return "row-debit"
          // } else if (parseFloat(item.markup) < 0) {
          //   return "row-debit"
        } else {
          return "";
        }
      } else {
        return null;
      }
    },
    async outputTSV() {
      let result = "";
      for (let j = 0; j < this.items.length; j++) {
        let line = "";

        // HEADER
        if (j == 0) {
          for (let k = 0; k < this.fields.length; k++) {
            if (this.fields[k].key == "selected" || this.fields[k].key == "icon" || this.fields[k].key == "actions") {
            } else {
              line += this.fields[k].label + "\t";
            }
          }
          if (line.length > 0) {
            line = line.slice(0, -1);
          }
          result += line + "\n";
          line = "";
        }

        let obj = this.items[j];

        // USE FIELDS IN CASE AN OBJECT IS NOT COMPLETE
        for (let k = 0; k < this.fields.length; k++) {
          let value = "";
          if (this.fields[k].key == "selected" || this.fields[k].key == "icon" || this.fields[k].key == "actions") {
          } else {
            value = obj[this.fields[k].key] ? obj[this.fields[k].key] : ""
            if (
              (this.fields[k].key.toLowerCase().includes('date') ||
                this.fields[k].key.toLowerCase().includes('modified') ||
                this.fields[k].key.toLowerCase().includes('issued') ||
                this.fields[k].key.toLowerCase().includes('invoice_at') ||
                this.fields[k].key.toLowerCase().includes('start_at')
              ) &&
              !this.fields[k].key.toLowerCase().includes('updated')) {
              value = this.$moment.unix(value / 1000).format("DD/MM/YY")
            }
            if (value) {
              value = value
                .toString()
                .replace(/(\r\n|\n|\r)/gm, "")
                .replace(/""/g, '"');
            }
            line += value + "\t";
          }

        }
        if (line.length > 0) {
          line = line.slice(0, -1);
        }

        result += line + "\n";
      }

      return result;
    },
  },

};
</script>

<style></style>